import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  getApiEncounterGetVitalsEncounterId,
} from 'endpoints';
import {
  isNilOrZero,
} from '@populateui/utils';
import {
  VitalsData,
} from 'pages/Dashboard/pages/Encounters/pages/List/components/PatientDetails/Vitals/types';

export default function useGetVitals(encounterId: number): UseQueryResult<VitalsData, Error> {
  return useQuery<VitalsData, Error>({
    queryKey: ['encounter-vitals', encounterId],
    queryFn: () => getApiEncounterGetVitalsEncounterId(encounterId),
    enabled: !isNilOrZero(encounterId),
  });
}
